export enum PromoStateEnum {
    ALL = 'all',
    ACTIVE = 'active',
    IN_ACTIVE = 'inactive',
}
